import React from 'react';
import VisualizationDocPage from '@splunk/visualizations-shared/VisualizationDocPage';
import OptionsDoc from '@splunk/dashboard-visualizations/common/OptionsDoc';
import DocExample from '@splunk/react-docs/DocExample';

import BasicExampleCode from '!!raw-loader!./examples/Basic';
import FontFamilyCode from '!!raw-loader!./examples/FontFamily';
import FontSizeCode from '!!raw-loader!./examples/FontSize';
import FontWeightCode from '!!raw-loader!./examples/FontWeight';
import LineHeightCode from '!!raw-loader!./examples/LineHeight';
import RotationCode from '!!raw-loader!./examples/Rotation';
import TextColorCode from '!!raw-loader!./examples/TextColor';
import BackgroundColorCode from '!!raw-loader!./examples/BackgroundColor';

import BasicExample from './examples/Basic';
import FontFamilyExample from './examples/FontFamily';
import FontSizeExample from './examples/FontSize';
import FontWeightExample from './examples/FontWeight';
import LineHeightExample from './examples/LineHeight';
import RotationExample from './examples/Rotation';
import TextColorExample from './examples/TextColor';
import BackgroundColorExample from './examples/BackgroundColor';

import optionsSchema from '../optionsSchema';

function TextDoc() {
    return (
        <VisualizationDocPage
            title="Text"
            examplesSection={[
                <DocExample
                    title="Basic Text"
                    key="basic_text"
                    description="Default options, text content"
                    code={BasicExampleCode}
                    example={BasicExample}
                />,
                <DocExample
                    title="Font Family is Times New Roman"
                    key="fontfamily"
                    code={FontFamilyCode}
                    example={FontFamilyExample}
                />,
                <DocExample
                    title="Font Size is 48"
                    key="fontsize"
                    code={FontSizeCode}
                    example={FontSizeExample}
                />,
                <DocExample
                    title="Font Weight is bold"
                    key="fontweight"
                    code={FontWeightCode}
                    example={FontWeightExample}
                />,
                <DocExample
                    title="Line Height is 200"
                    key="lineheight"
                    code={LineHeightCode}
                    example={LineHeightExample}
                />,
                <DocExample
                    title="Line Height is 200, Rotation is 10"
                    key="rotation"
                    code={RotationCode}
                    example={RotationExample}
                />,
                <DocExample
                    title="Text Color is blue"
                    key="textcolor"
                    code={TextColorCode}
                    example={TextColorExample}
                />,
                <DocExample
                    title="Background Color is green"
                    key="backgroundcolor"
                    code={BackgroundColorCode}
                    example={BackgroundColorExample}
                />,
            ]}
            optionSection={<OptionsDoc options={optionsSchema} />}
        />
    );
}

export default TextDoc;
